import React, { useEffect, useState } from "react";
import { client } from "../../lib/sanityClient";
import { allArticlesQuery } from "../../lib/queries";
import { NewsCard } from "../../components/cards/NewsCard";
import { Layout } from "../../components/layout";
import { Animate } from "../../components/animate";

const SkeletonCard = () => (
  <div className="rounded-[32px] overflow-hidden border border-grey-200 bg-white animate-pulse">
    <div className="w-full aspect-[16/9] bg-grey-100" />
    <div className="p-6 flex flex-col gap-3">
      <div className="h-5 w-24 bg-grey-100 rounded-full" />
      <div className="h-6 w-full bg-grey-100 rounded-lg" />
      <div className="h-4 w-3/4 bg-grey-100 rounded-lg" />
      <div className="h-4 w-1/2 bg-grey-100 rounded-lg" />
    </div>
  </div>
);

export const BlogListPage = () => {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    client
      .fetch(allArticlesQuery, { test: process.env.NODE_ENV === "development" })
      .then((data) => setArticles(data))
      .catch(() => setArticles([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <Layout>
      <div className="w-full">
        {/* Hero */}
        <div className="bg-light-yellow py-[64px] lg:py-[80px]">
          <div className="max-width">
            <Animate animation="fade-down">
              <p className="text-grey-500 text-sm font-semibold uppercase tracking-widest mb-4">
                News & Updates
              </p>
              <h1 className="text-deep-primary font-medium text-[48px] lg:text-[72px] tracking-[-0.03em] leading-[52px] lg:leading-[76px] max-w-[700px]">
                Insights from{" "}
                <span className="italic text-primary font-normal">
                  MyCard Global
                </span>
              </h1>
              <p className="mt-4 text-grey-600 text-base lg:text-lg max-w-[520px]">
                Product updates, financial tips, and company news - all in one
                place.
              </p>
            </Animate>
          </div>
        </div>

        {/* Articles grid */}
        <div className="py-[56px] lg:py-[80px]">
          <div className="max-width">
            {loading ? (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
                {[0, 1, 2, 3, 4, 5].map((i) => (
                  <SkeletonCard key={i} />
                ))}
              </div>
            ) : articles.length === 0 ? (
              <div className="flex flex-col items-center justify-center py-[80px] gap-4 text-center">
                <p className="text-deep-primary text-2xl font-medium">
                  No articles yet
                </p>
                <p className="text-grey-500 text-base max-w-[340px]">
                  We're working on something great. Check back soon.
                </p>
              </div>
            ) : (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
                {articles.map((article, idx) => (
                  <Animate
                    key={article._id}
                    animation="fade-up"
                    delay={(idx % 3) * 0.1}
                  >
                    <NewsCard {...article} />
                  </Animate>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </Layout>
  );
};
